import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useLanguage } from '../i18n/LanguageContext';
import { loadPaymentDraft } from '../booking/storage';

function RedirectAfterLogin() {
  const navigate = useNavigate();
  const { refreshSession } = useAuth();
  const { language } = useLanguage();

  useEffect(() => {
    const doRedirect = async () => {
      try {
        const user = await refreshSession();
        if (!user) throw new Error(language === 'fr' ? 'Non authentifie' : 'Not authenticated');
        const paymentDraft = loadPaymentDraft();

        if (paymentDraft?.appointmentData && paymentDraft?.servicePriceCents) {
          navigate('/paiement', { replace: true });
          return;
        }

        if (user.user_type === 'professional') {
          navigate('/professional/dashboard');
        } else if (user.user_type === 'patient') {
          navigate('/patient/dashboard');
        } else {
          console.error('❌ Unknown user type:', user.user_type);
          navigate('/connexion');
        }
      } catch (err) {
        console.error('❌ Redirect error:', err);
        navigate('/connexion');
      }
    };

    doRedirect();
  }, [language, navigate, refreshSession]);

  return <p>{language === 'fr' ? 'Connexion en cours...' : 'Signing you in...'}</p>;
}

export default RedirectAfterLogin;
